import produce from "immer";
import { isBlank } from "utils/string";
import { State } from "../types";

import { ActionType } from "@dashboard-v3/api";
import { typePath } from "pages/Rules/Form/context/ruleSelectors";

export type UpdateFilterPolicy = {
  type: "updateFilterPolicy";
  payload: { filterPolicyId: string; filterType: "ACTION" | "TARGET" };
};

const rulesWithContentFilter: ActionType[] = [
  "BLOCK_ATTACHMENTS",
  "REQUEST_APPROVAL",
  "SEND_DELAY",
];

export function updateFilterPolicy(
  state: State,
  payload: UpdateFilterPolicy["payload"]
): State {
  return produce(state, draft => {
    if (payload.filterType === "ACTION") {
      const rule = typePath(draft.rule.actionType, draft.rule);
      const hasContentFilter = rulesWithContentFilter.includes(
        draft.rule.actionType
      );

      if (hasContentFilter && "contentFilter" in rule) {
        !isBlank(payload.filterPolicyId)
          ? (rule.contentFilter.filterPolicyId = payload.filterPolicyId)
          : delete rule.contentFilter.filterPolicyId;
      }

      if (!hasContentFilter && "contentToSave" in rule) {
        !isBlank(payload.filterPolicyId)
          ? (rule.contentToSave.filter.filterPolicyId = payload.filterPolicyId)
          : delete rule.contentToSave.filter.filterPolicyId;
      }
    }

    if (payload.filterType === "TARGET") {
      !isBlank(payload.filterPolicyId)
        ? (draft.rule.filterPolicyId = payload.filterPolicyId)
        : delete draft.rule.filterPolicyId;
    }
  });
}
